var _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgIconNfc = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-117.1,22a.987.987,0,0,1-.62-.217,1,1,0,0,1-.163-1.4,13.363,13.363,0,0,0,1.917-3.286,1,1,0,0,1,1.3-.551,1,1,0,0,1,.552,1.3,15.366,15.366,0,0,1-2.2,3.776A1,1,0,0,1-117.1,22Zm-3.747-1.9a1,1,0,0,1-.619-.215,1,1,0,0,1-.166-1.405,10.318,10.318,0,0,0,2.171-6.376,10.224,10.224,0,0,0-2.476-6.744,1,1,0,0,1,.094-1.411,1,1,0,0,1,1.411.1,12.218,12.218,0,0,1,2.971,8.06,12.329,12.329,0,0,1-2.6,7.615A1,1,0,0,1-120.85,20.1Zm-3.286-2.525h-.013a1,1,0,0,1-.747-.35l-5.836-6.826A6.033,6.033,0,0,0-131,12.1a5.954,5.954,0,0,0,.746,2.915,1,1,0,0,1-.383,1.362A1,1,0,0,1-132,16a7.968,7.968,0,0,1-1-3.9,8.54,8.54,0,0,1,1.113-4.071,1,1,0,0,1,.774-.5,1,1,0,0,1,.856.345l6.007,7.028a7.167,7.167,0,0,0,.457-2.8,6.862,6.862,0,0,0-1.927-4.409,1,1,0,0,1,.026-1.414,1,1,0,0,1,1.414.026,8.826,8.826,0,0,1,2.487,5.8,7.275,7.275,0,0,1-1.6,5.14A1,1,0,0,1-124.136,17.574ZM-114.124,15a1.013,1.013,0,0,1-.133-.009,1,1,0,0,1-.859-1.123A13.462,13.462,0,0,0-115,12.1a13.361,13.361,0,0,0-3.028-8.468,1,1,0,0,1,.137-1.407,1,1,0,0,1,1.408.137A15.368,15.368,0,0,1-113,12.1a15.4,15.4,0,0,1-.134,2.029A1,1,0,0,1-114.124,15Z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconNfc, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-nfc.0a433d5a.svg";
export { ForwardRef as ReactComponent };